import React from "react";
import styled, { css } from "styled-components";
import Container from "./Container";
import Section from "./Section";
import SafeSiteImage from "./SafeSiteImage";
import { HtmlContent } from "./Content";

const TableStyles = styled.div`
  ${({ ...props }) => css`
    h2 {
      font-size: 1.1rem;
      font-weight: normal;
      line-height: 1.2;
      padding-left: 14px;
      padding-right: 14px;
      padding-bottom: 14px;
    }
    .tableWrapper {
      overflow-x: auto;
    }
    table {
      border-top: ${props.$showProductFeaturedImageAndTitle ? 'none' : '1px solid #707070'};
      border-spacing: 0;
      font-size: 1.1rem;
      width: 100%;
      text-align: left;
      tbody tr:nth-of-type(odd) {
        background-color: #ECECE9
      }
    }
    td, th {
      padding: 14px;
    }
    th img {
      max-width: 150px;
      margin-bottom: 14px;
      object-fit: cover;
      border-radius: 4px
    }
    &.row-style {
      tbody tr:first-of-type th,
      tbody tr:first-of-type td {
        border-top: 1px solid #707070;
      }
      tbody tr th:first-of-type {
        position: sticky;
        left: 0;
        background-color: inherit
      }
      tbody tr:nth-of-type(even) {
        background-color: #ECECE9
      }
      tbody tr:nth-of-type(odd) {
        background-color: white
      }
    }
    @media (min-width: ${props.theme.breakpoints.md}) {
      table, h2 {
        font-size: 1.25rem;
      }
    }
  `}
`;

export const Table = ({ title, showProductFeaturedImageAndTitle = false, specifications, products }) => {
  if (!Array.isArray(specifications) && !Array.isArray(products)) {
    return <></>;
  }

  const specToLabel = (spec) => {
    switch (spec) {
      case 'width':
        return 'Width'
      case 'depth':
        return 'Depth'
      case 'height':
        return 'Height'
      case 'weight':
        return 'Weight'
      case 'filledWeight': 
      return 'Filled Weight'
    }
  }

  products.forEach((product) => {
    let featuredImageData;
    // Select either the featured, the first one in gallery
    if (product.featuredImage) {
      featuredImageData = product.featuredImage.node;
    } else if (
      product.productData?.productGallery &&
      product.productData.productGallery.length > 1
    ) {
      featuredImageData = product.productData.productGallery[0];
    }

    product.image = featuredImageData
  })

  return (
    <Section>
      <Container>
        <TableStyles
          $showProductFeaturedImageAndTitle={showProductFeaturedImageAndTitle}
          className={showProductFeaturedImageAndTitle && 'row-style'}
        >
          {title && (
            <h2>
              <HtmlContent htmlString={title} />
            </h2>
          )}
          <div className="tableWrapper">
            <table>
              <thead>
                <tr>
                  {showProductFeaturedImageAndTitle ? (
                    <>
                      <th/>
                      {products.map((product, index) => {
                        return (
                          <th key={`${product.productData.productId}${index}`}>
                            {product.image && <SafeSiteImage image={product.image.mediaItemUrl} alt={product.image.alt} width="150" />}
                            <span>
                              <HtmlContent htmlString={product.title} />
                            </span>
                          </th>
                        )
                      })}
                    </>
                  ) : (
                    <>
                      <th>Product ID</th>
                      {specifications.map((spec, index) => {
                        return (
                          <th key={`${spec}${index}`}>{specToLabel(spec)}</th>
                        )
                      })}
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
              {showProductFeaturedImageAndTitle ? (
                <>
                  <tr>
                    <th>Product ID</th>
                    {products.map((product, index) => {
                      return (
                        <td key={`${product.productData.productId}${index}`}>
                          {product.productData.productId}
                        </td>
                      )
                    })}
                  </tr>
                  {specifications.map((spec, index) => {
                    return (
                      <tr key={`${spec}${index}`}>
                        <th>{specToLabel(spec)}</th>
                        {products.map((product, index) => {
                          return (
                            <td key={`${product.productData.specification[spec]}${index}`}>
                              {product.productData.specification[spec]}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </>
              ) : (
                <>
                  {products.map((product, index) => {
                    return (
                      <tr key={`${product.productData.productId}${index}`}>
                        <td>{product.productData.productId}</td>
                        {specifications.map((spec, specIndex) => {
                          return (
                            <td key={`${product.productData.specification[spec]}${specIndex}`}>
                              {product.productData.specification[spec]}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                  </>
                )
              }
              </tbody>
            </table>
          </div>
        </TableStyles>
      </Container>
    </Section>
  )
};
